import React, { FC, PropsWithChildren } from 'react';
import { CSSTransition } from 'react-transition-group';

import { ComposedTheme, useTheme } from '@glu/theming';

import useStyles from './Fade.styles';

/* istanbul ignore next */

interface Props {
  mountOnEnter: boolean;
  in: boolean;
  unmountOnExit: boolean;
}

export const FadeComponent: FC<PropsWithChildren<Props>> = ({
  children,
  in: show = false,
  mountOnEnter = true,
  unmountOnExit = true
}) => {
  const {
    transitions: {
      duration: { short }
    }
  } = useTheme<ComposedTheme>();
  const { fade } = useStyles();
  return (
    <CSSTransition
      in={show}
      classNames={fade}
      timeout={short}
      mountOnEnter={mountOnEnter}
      unmountOnExit={unmountOnExit}
    >
      {children}
    </CSSTransition>
  );
};

export default FadeComponent;
